import { CrossAppMessagingService } from './core/_services/crossApp-messaging.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Component, Inject, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AuthorizationService } from './core/_services/authorization.service';
import { environment } from 'src/environments/environment';
import { DeviceService } from './core/_services/device.service';
import { SessionService } from './core/_services/session.service';
import { BackNavigationService } from './core/_services/backNavigation.service';
import { DeviceProfileService } from './core/_services/device-profile.service';
import { DeliveryLocationService } from './delivery/_services/delivery-location.service';
import { combineLatest } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './core/_services/language.service';
import { ThemeService } from './core/_services/theme.service';
import { SettingsService } from './delivery/_services/settings.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'Dostava - eMeni.rs';
  environment = environment;

  /** Show the shared device bar only on the login screen. */
  get onLogin(): boolean {
    return (this.router.url || '').startsWith('/login');
  }

  constructor(auth: AuthorizationService,
    public router: Router,
    session: SessionService,
    crossAppMessaging: CrossAppMessagingService,
    device: DeviceService,
    backNavigationService: BackNavigationService,
    deviceProfileService: DeviceProfileService,
    deliveryLocation: DeliveryLocationService,
    dialog: MatDialog,
    languageService: LanguageService,
    translate: TranslateService,
    settingsService: SettingsService,
    theme: ThemeService
  ) {

    // Tema je deo podešavanja uređaja (ThemeService je ne čuva sam) — primenjuje se odmah pri
    // pokretanju, u istom tasku kao pre-boot skripta u index.html, pa nema treptaja. Provera je
    // bitna: set('auto') svaki put računa sunce i tajmer.
    settingsService.settings.subscribe(
      val => {
        if (val.theme !== theme.current) {
          theme.set(val.theme);
        }
      }
    );

    // Izbor jezika (LanguageService pamti izbor po uređaju, uz `?lang=` iz URL-a kao najviši
    // prioritet) primenjuje app, isto kao konobar, admin i kiosk. Pretplata ujedno instancira
    // servis, pa se sačuvani jezik primeni odmah po pokretanju.
    languageService.currentLanguage.subscribe(
      lang => {
        if (lang) {
          translate.use(lang);
        }
      }
    );
    // ── Profil podešavanja uređaja ──
    // MVP: delivery app nema lokalni settings store, ali prosleđuje native sekciju profila
    // shell-u (no-op van native app-a). Delivery ne koristi WS, pa nema live push-a promene
    // profila — dovuče se jednom na startu (i na sledećem pokretanju app-a).
    const fetchProfile = () => {
      deviceProfileService.getMyProfile().subscribe({
        next: payload => {
          if (payload?.nativeSettings) {
            crossAppMessaging?.sendRawMessage({
              action: 'applyProfileNativeSection',
              data: JSON.stringify(payload.nativeSettings)
            });
          }
        },
        error: () => { } // offline/bez profila — ignoriši
      });
    };

    fetchProfile();

    // Browser / Android Back closes only the topmost open layer (dialog or the
    // embedded order screen), not the whole screen. See BackNavigationService.
    backNavigationService.init(dialog, router);

    session.selectedCompany.subscribe(company => {
      var msg = {
        action: "setCompany",
        data: company
      };
      crossAppMessaging?.sendRawMessage(msg);
    });


    session.companySettings.subscribe(settings => {
      var msg = {
        action: "setCompanySettings",
        data: settings
      };
      crossAppMessaging?.sendRawMessage(msg);
    });

    auth.sessionExpired.subscribe(
      () => router.navigate(['/login'], { state: { invalidSession: true } })
    )

    // Slanje pozicije vozača: kreni kad je ulogovan i firma izabrana, stani na odjavu.
    // Native šalje i u pozadini do odjave; web fallback samo dok je tab otvoren.
    combineLatest([auth.currentUser, session.selectedCompany]).subscribe(([user, company]) => {
      if (user && company) {
        deliveryLocation.start(company.companyID);
      } else {
        deliveryLocation.stop();
      }
    });

    if (environment.nativeApp) {
      inject(CrossAppMessagingService)?.sendRawMessage({
        action: "appLoaded",
        data: { ...environment }
      });

      inject(CrossAppMessagingService)?.sendRawMessage({
        action: "deviceID",
        data: device.deviceID
      });
    };
  }
}
